// src/pages/Login.jsx
import React, { useState } from "react";
import { Container, TextField, Button, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import api from "../../utils/api";

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // 1) try Master
    try {
      const { data } = await api.post("/api/master/login", form);
      login({ ...data.user, role: "master", token: data.token });
      return navigate("/master/dashboard");
    } catch {
      /* fall through */
    }

    // 2) try Super-Admin
    try {
      const { data } = await api.post("/api/super-admin/login", form);
      login({ ...data.user, role: "superadmin", token: data.token });
      return navigate("/super-admin/dashboard");
    } catch {
      /* fall through */
    }

    // 3) try User (Manager or Billing Staff)
    try {
      const { data } = await api.post("/api/users/login", form);
      const userRole = data.user.role.toLowerCase().includes("manager")
        ? "manager"
        : "billing";
      login({ ...data.user, role: userRole, token: data.token });
      return navigate(`/${userRole}/dashboard`);
    } catch {
      alert("Invalid email or password");
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Login
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            name="email"
            label="Email"
            value={form.email}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            fullWidth
            name="password"
            label="Password"
            type="password"
            value={form.password}
            onChange={handleChange}
            margin="normal"
          />
          <Button fullWidth type="submit" variant="contained" sx={{ mt: 2 }}>
            Login
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default Login;
